<template>
  <div v-if="tableRows.length" class="mt-6">
    <div>
      <!--<b-modal :active.sync="isCardModalActive" :width="640" scroll="keep" v-bind:class="{ 'is-hidden': !isCardModalActive }">-->
      <div class="modal is-active" v-bind:class="{ 'is-hidden': !isCardModalActive }">
        <div class="modal-background" @click="isCardModalActive = false"></div>
        <div class="animation-content modal-content" style="max-width: 640px">
          <div class="card">
            <div class="card-content">
              <div>
                <h2 class="title is-size-4 is-uppercase">{{ $t('summary.your_choices') }}</h2>
                <div class="columns is-centered printable" id="choicesTable" ref="choicesTable">
                  <table class="table is-narrow is-fullwidth-mobile dd-table">
                    <tr v-for="selection in selections" :key="selection.name">
                      <td class="has-text-weight-bold has-text-right">
                        {{ selection.name }}
                      </td>
                      <td>{{ selection.value }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="only-printable" id="choicesTablePrint" ref="choicesTablePrint"></div>
      <!--</b-modal>-->
      <b-modal :active.sync="emailSummarySent" :width="640" scroll="keep">
        <div class="card">
          <div class="card-content">
            <p class="is-size-6 is-size-5-tablet">
              {{ $t('summary.email_sent') }}:
              <b class="has-text-weight-bold">{{ emailSummaryReceiver }}</b>
            </p>
          </div>
        </div>
      </b-modal>
    </div>
    <table class="table margin-xxxlarge-vertical is-fullwidth is-size-7" id="summaryTable" ref="summaryTable">
      <thead>
        <tr>
          <th class="is-uppercase has-text-left">{{ $t('generic.product') }}</th>
          <!-- <th class="is-uppercase is-hidden-mobile">Färg</th> -->
          <th class="is-uppercase has-text-right">{{ $t('generic.amount') }}</th>
          <!-- <th class="is-uppercase has-text-right"><span class="is-hidden-mobile">Antal </span>pall</th>
          <th class="is-uppercase has-text-right">Vikt</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="tableRow in sortedTableRows" v-bind:key="tableRow.artNbr">
          <td class="has-text-left is-size-6">
            {{ tableRow.product }}
            <span class="is-block has-text-weight-normal has-text-light is-size-8">{{ $t('generic.artnr') }}{{
              tableRow.artNbr }}</span>
          </td>
          <!-- <td class="is-hidden-mobile">{{ tableRow.color }}</td> -->
          <td class="has-text-right is-size-6">{{ tableRow.qty }} {{ tableRow.qty != '-' ? tableRow.unit : '' }}</td>
          <!-- <td class="has-text-right">{{ tableRow.pallets }} {{ tableRow.pallets != '-' ? 'st' : '' }}</td>
          <td class="has-text-right">{{ tableRow.weight }} {{ tableRow.weight != '-' ? 'kg' : '' }}</td> -->
        </tr>
        <!-- <tr class="tfoot">
          <td class="has-text-right has-text-weight-bold is-hidden-mobile" colspan="4">{{ palltes }}</td>
          <td class="has-text-right has-text-weight-bold is-hidden-tablet" colspan="3">{{ palltes }}</td>
          <td class="has-text-right has-text-weight-bold" colspan="3">{{ weight }}</td>
        </tr> -->
      </tbody>
    </table>

    <div class="non-printable disclaimer space-under is-size-7">
      <p>
        {{ $t('summary.disclaimer') }}
        <a :href="articleInfoUrl" class="non-printable" target="_blank">
          {{ $t('summary.disclaimer_link') }}
        </a>
      </p>
    </div>

    <div ref="disclaimer" class="only-printable disclaimer space-under is-size-7">
      <p>
        {{ $t('summary.disclaimer') }}
      </p>
    </div>
    <div class="non-printable">
      <nav class="level center">
        <div class="level-right">
          <div class="level-item">
            <form method="POST" target="_blank" :action="pdfSummaryAction" ref="pdfSummaryForm">
              <input type="hidden" name="name" :value="pdfSummaryName" />
              <input type="hidden" name="body" :value="pdfSummaryBody" />
              <input type="hidden" name="print" :value="pdfSummaryPrint ? 'y' : 'n'" />
              <b-button size="is-small" type="is-link" class="is-uppercase has-text-weight-bold"
                v-on:click="pdfSummarySubmit">{{
                  $t('summary.save_pdf')
                }}</b-button>
            </form>
          </div>
          <div class="level-item">
            <b-button size="is-small" type="is-link" class="is-uppercase has-text-weight-bold"
              v-on:click="printSummary">{{ $t('summary.print') }}</b-button>
          </div>
          <div v-if="showAddToCartBtn" class="level-item">
            <b-button size="is-small" type="is-link" class="is-uppercase has-text-weight-bold" v-on:click="addToCart"
              :disabled="$store.state.frameData.loading" v-button-loader:dot-collision="$store.state.frameData.loading">
              {{ $t('summary.add_to_cart') }}
            </b-button>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import fetch from 'fetch-retry';
import moment from 'moment';
import _ from 'lodash';

/**
 * just a Promise wrapper around addEventListener
 * @param {HTMLElement} emitter
 * @param {String} eventName
 * @return {Promise}
 */
function fromEvent(emitter, eventName) {
  return new Promise((resolve) => {
    emitter.addEventListener(eventName, resolve);
  });
}
/**
 * @param {HTMLIFrameElement} iframe
 * @param {String} html
 * @return {Promise}
 */
function setSrcdocForIframeWithHtml(iframe, html) {
  iframe.setAttribute('srcdoc', html);

  // In Edge 17 all of that does not work, though Edge 18 will probably support srcdoc
  const isBadEdge = /Edge\/17\.\d+/.test(navigator.userAgent) || /Edge\/18\.\d+/.test(navigator.userAgent);

  if (!isBadEdge) {
    var jsUrl = "javascript: window.frameElement.getAttribute('srcdoc');";
    iframe.setAttribute('src', jsUrl);
    // Explicitly set the iFrame's window.location for
    // compatibility with IE9, which does not react to changes in
    // the `src` attribute when it is a `javascript:` URL, for
    // some reason
    if (iframe.contentWindow) {
      iframe.contentWindow.location = jsUrl;
    }
    return fromEvent(iframe, 'load');
  }
  return fromEvent(iframe, 'load').then(() => {
    iframe.contentWindow._my_app_getSource = function () {
      return html;
    };
    iframe.contentWindow.location = 'javascript: _my_app_getSource()';
    return fromEvent(iframe, 'load');
  });
}

const isIE = navigator.userAgent.toLowerCase().indexOf('msie') !== -1 || !!navigator.userAgent.match(/Trident.*rv:11\./);

// const retryOpts = {
//     retries: 4,
//     retryDelay: function(attempt) {
//       return Math.pow(2, attempt) * 1000;
//     }
// }

export default {
  name: 'summaryStep',
  props: ['activeStep'],
  data: function () {
    return {
      isCardModalActive: false,
      queryResult: null,
      tsQueryResult: new Map(),
      hsQueryResult: null,
      ssQueryResult: null,
      email: null,
      emailSummaryReceiver: null,
      emailSummarySent: false,
      extrasQueryResult: null,
      tsQueryResultChangeCounter: 0,
      pdfSummaryBody: null,
      pdfSummaryPrint: false,
    };
  },
  computed: {
    products() {
      return this.$store.getters.getProducts;
    },
    selections() {
      let selections = this.$store.getters.getSelections;

      let filteredSelections = { ...selections };
      delete filteredSelections.fillingMaterialId;
      delete filteredSelections.fillingMaterialColor;
      filteredSelections.selectedMaterial = {
        value: this.selectedMaterialObj.name,
        name: 'Fogmaterial',
        sortingorder: 6,
      };
      console.log(this.selectedMaterialObj);

      let selectionsArr = Object.values(filteredSelections);
      console.log(selectionsArr);
      selectionsArr.sort((a, b) => (a.sortingorder > b.sortingorder ? 1 : -1));
      console.log(selectionsArr);

      return selectionsArr;
    },
    selectedMaterialObj() {
      return this.$store.getters.getSelectedMaterialObj;
    },
    amountJointFillingKg() {
      return this.$store.getters.getAmountJointFillingKg;
    },

    pdfSummaryAction() {
      return process.env.VUE_APP_API_URL + ':' + process.env.VUE_APP_API_PORT + '/api/pdfSummary';
    },
    tableRows: function () {
      // let allowBigpack = this.$store.getters.getSelectedValue('bigpack')
      let table = [];

      if (this.amountJointFillingKg && !_.isEmpty(this.selectedMaterialObj)) {
        table.push({
          product: this.selectedMaterialObj.name,
          artNbr: this.selectedMaterialObj.artNumber,
          color: this.selectedMaterialObj.color,
          qty: Math.ceil(this.amountJointFillingKg / this.selectedMaterialObj.weightKg),
          // pallets:  1,
          // weight:   2,
          values: 1,
          unit: this.selectedMaterialObj.unit,
          sort: 1, //this.sortValue(product)
        });
      }
      return table;
    },
    sortedTableRows() {
      return [...this.tableRows].sort((a, b) => {
        return a.sort - b.sort;
      });
    },
    weight: function () {
      var table = this.tableRows;
      var tot_pallets = 0;
      var weightSum = 0;
      for (var i = 0; i < table.length; i++) {
        if (table[i].artNbr == '099900') tot_pallets = table[i].pallets;
        if (table[i].artNbr == '099900' || isNaN(table[i].values.weight)) continue;
        var qty = table[i].qty > 0 ? table[i].qty : 1;
        weightSum += Math.round(table[i].values.weight * qty);
      }
      weightSum += tot_pallets * 20.0;
      return weightSum.toLocaleString('sv-SE') + ' kg';
    },
    palltes: function () {
      var table = this.tableRows;
      var palletSum = 0;
      for (var i = 0; i < table.length; i++) {
        if (table[i].artNbr == '099900' || isNaN(table[i].pallets)) continue;
        var qty = table[i].qty > 0 ? table[i].qty : 1;
        palletSum += Math.ceil(qty / table[i].values.nPerPall);
      }
      return palletSum.toLocaleString('sv-SE') + ' st';
    },
    pdfSummaryName() {
      // return `Benders Murberäkning ${this.$store.getters.getSelectedProduct.name} ${this.$store.getters.getSelectedShape.name} ${moment().format('YYYY-MM-DD')}`
      return this.$t('summary.pdf_name', { date: moment().format('YYYY-MM-DD') });
    },
    showAddToCartBtn() {
      if (!window.parent) {
        return false;
      }
      // const region = this.$store.state.country.id.substr(3, 2).toLowerCase();
      // if (region !== "se") {
      //   return false;
      // }
      return this.$store.state.frameData.canBuy;
    },
    articleInfoUrl() {
      let article = this.tableRows && this.tableRows[0] ? this.tableRows[0].artNbr : null;
      switch (article) {
        case '2984107-D':
        case '2984101-D':
        case '2984110-D':
          return 'https://s3.portal.benders.se/produktapi/documents/10020697.pdf';
        case '2983507-E':
        case '2983501-E':
        case '2983565-E':
          return 'https://s3.portal.benders.se/produktapi/documents/10020669.pdf';
        case '2984617-E':
          return 'https://s3.portal.benders.se/produktapi/documents/10020703.pdf';
        case '2984907':
        case '2984901':
          return 'https://s3.portal.benders.se/produktapi/documents/10020674.pdf';
        case '2982607-E':
          return 'https://s3.portal.benders.se/produktapi/documents/10030138.pdf';
        case '2982765-A':
            return 'https://s3.portal.benders.se/produktapi/documents/10030139.pdf';
        case '2983717-A':
            return 'https://s3.portal.benders.se/produktapi/documents/10030136.pdf';
        case '2983407-A':
            return 'https://s3.portal.benders.se/produktapi/documents/10026252.pdf';
        case '2983617-A':
            return 'https://s3.portal.benders.se/produktapi/documents/10030137.pdf';
        case '2984210-D':
          return 'https://s3.portal.benders.se/produktapi/documents/10020698.pdf';
        case '2984210-B':
          return 'https://s3.portal.benders.se/produktapi/documents/10020699.pdf';
        case '2984210-C':
          return 'https://s3.portal.benders.se/produktapi/documents/10020700.pdf';
        case '2983920-D':
          return 'https://s3.portal.benders.se/produktapi/documents/10020672.pdf';
        case '2983920-B':
          return 'https://s3.portal.benders.se/produktapi/documents/10022636.pdf';
        case '2983920-C':
          return 'https://s3.portal.benders.se/produktapi/documents/10020412.pdf';
        default:
          return '';
      }
    },
  },
  methods: {
    goToStep(step) {
      this.$store.dispatch('goToStep', step);
    },
    pdfSummarySubmit() {
      this.pdfSummaryBody = JSON.stringify({
        name: this.pdfSummaryName,
        choices: this.$refs.choicesTable.outerHTML,
        summary: this.$refs.summaryTable.outerHTML,
        disclaimer: this.$refs.disclaimer.outerHTML,
      });
      this.pdfSummaryPrint = false;

      this.$nextTick(() => {
        this.$refs.pdfSummaryForm.submit();
      });
    },
    printSummary() {
      this.pdfSummaryBody = JSON.stringify({
        choices: this.$refs.choicesTable.outerHTML,
        summary: this.$refs.summaryTable.outerHTML,
        disclaimer: this.$refs.disclaimer.outerHTML,
      });
      this.pdfSummaryPrint = true;

      /**
       * Vad som händer här är:
       * 1. Vänta på nextTick (För att pdfSummaryPrint och pdfSummaryBody uppdateringen ska slå igenom
       * 2. Emulera formulär submit
       * 3. Response är ett komplett htmldocument (samma markup som skulle hamnat i PDF:en)
       * 4. Vi skickar in all markup i en dold iframe (srcdoc)
       * 5. När iframe är färdigladdad så triggar vi focus och print som visar utskriftsdialogen
       * 6. Efter 120sek så tar vi bort iframe från DOM, för att städa lite
       */

      this.$nextTick(() => {
        fetch(this.pdfSummaryAction, {
          method: 'POST',
          body: new FormData(this.$refs.pdfSummaryForm),
        })
          .then((resp) => resp.text())
          .then((text) => {
            var iframe = document.createElement('IFRAME');

            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            setSrcdocForIframeWithHtml(iframe, text).then(() => {
              iframe.contentWindow.focus();

              if (isIE) {
                iframe.contentWindow.document.execCommand('print', false, null);
              } else {
                iframe.contentWindow.print();
              }

              setTimeout(() => {
                document.body.removeChild(iframe);
              }, 120000);
            });
          });
      });
    },
    emailSummary: function () {
      if (!this.validEmail(this.email)) return;
      fetch(process.env.VUE_APP_API_URL + ':' + process.env.VUE_APP_API_PORT + '/api/emailSummary', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: this.email,
          choices: this.$refs.choicesTable.outerHTML,
          summary: this.$refs.summaryTable.outerHTML,
          disclaimer: this.$refs.disclaimer.outerHTML,
        }),
      }).then((request) => {
        request.json().then((data) => {
          if (data.sent == true) {
            this.emailSummaryReceiver = this.email;
            this.emailSummarySent = true;
            this.email = null;
          }
        });
      });
    },
    validEmail: function (email) {
      // eslint-disable-next-line no-useless-escape
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },
    amountOf: function (lengthsArr = [], divideBy = 1) {
      // Tror inte att det ska summeras innan som i excel
      // Bättre att ta alla längder delat med 2,1 för att få ut antal
      let total = 0;
      lengthsArr.forEach((distance) => {
        if (!isNaN(Number(distance))) {
          total += Math.ceil(Number(distance) / divideBy);
        }
      });
      return total;
    },
    bigpack: function (product, amount) {
      return [amount % product.bundle, Math.floor(amount / product.bundle)];
    },
    addToCart() {
      if (!this.showAddToCartBtn) {
        return;
      }
      const rows = this.sortedTableRows.filter((row) => row.artNbr !== '099900');
      window.parent.postMessage(
        {
          type: 'bendersAddToCart',
          items: rows.map((row) => ({
            artNumber: row.artNbr,
            qty: row.qty,
            unit: row.unit,
            color: row.color || null,
            // artId:
            //   row.dynamicInfo && row.dynamicInfo.id
            //     ? row.dynamicInfo.id
            //     : null,
          })),
          mainArticle: rows.length ? rows[0].artNbr : null,
          preferredWarehouse: this.$store.state.frameData.defaultWarehouse,
        },
        '*'
      );
    },
  },
  components: {},
};
</script>

<style lang="sass" scoped>
@import "@/assets/styles/_variables.sass"
@import "@/assets/styles/_mixins.sass"

dl
  display: flex
  flex-wrap: wrap
  text-align: left
  dd, dt
    flex: 1 0 70%
    padding: 0 $size-7
  dt
    flex: 1 0 30%
    text-align: right

td
  white-space: nowrap
  &:first-of-type
    white-space: normal

.only-printable
  display: none

.disclaimer
  margin-bottom: 25px

.center
  display: flex
  flex-flow: row no-wrap
  justify-content: center

@media print
  .non-printable, .bg-svg
    display: none !important
  .only-printable
    display: block !important
  .hero-body
    display: block !important
    flex-grow: unset !important
  .container
    max-width: 100% !important
  .column
    flex: auto
    width: 100% !important
  .is-fullheigh
    min-height: auto

  .button, .title
    display: none !important

  body
    font-family: futura-pt, sans-serif

  table
    border-collapse: collapse
    border-spacing: 0
    color: #464749
    width: 100% !important
    min-width: 350px !important

  .table thead td, .table thead th
    text-align: left
    border-width: 0 0 2px
    color: #464744

  .table td, .table th
    text-align: left
    border: 1px solid #e2e3e4
    border-width: 0 0 1px
    padding: 0.5em 0.75em
    vertical-align: middle

  body .is-small
    font-size: 1rem !important
  .has-text-light
    color: #808285 !important
  body *
    font-size: 1.2rem !important
  body .is-size-8
    font-size: 0.85rem !important
  .tfoot td
    border-bottom: none !important
  .is-hidden-tablet
    display: none
  .logo
    background-image: url("data:image/svg+xml,%3Csvg width='113' height='50' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23FFFFFE' fill-rule='nonzero' d='M.004 49.996h112.721V.11H.005z'/%3E%3Cpath stroke='%23FFFFFE' stroke-width='.5' d='M.004 49.996h112.721V.11H.005z'/%3E%3Cpath fill='%239F2A3B' fill-rule='nonzero' d='M.944 9.901h7.045V1.042H.944zM8.928 9.901h7.045V1.042H8.928zM.944 19.691h7.045v-8.858H.944zM8.928 19.691h7.045v-8.858H8.928zM.944 29.482h7.045v-8.858H.944zM8.928 29.482h7.045v-8.858H8.928zM.944 39.273h7.045v-8.858H.944zM8.928 39.273h7.045v-8.858H8.928zM.944 49.064h7.045v-8.859H.944zM8.928 49.064h7.045v-8.859H8.928zM16.913 9.901h7.045V1.042h-7.045zM24.897 9.901h7.045V1.042h-7.045zM32.881 9.901h7.045V1.042h-7.045zM40.866 9.901h7.045V1.042h-7.045zM48.85 9.901h7.045V1.042H48.85zM56.834 9.901h7.045V1.042h-7.045zM64.819 9.901h7.045V1.042h-7.045zM72.803 9.901h7.045V1.042h-7.045zM80.787 9.901h7.045V1.042h-7.045zM88.772 9.901h7.045V1.042h-7.045zM16.913 49.064h7.045v-8.859h-7.045zM24.897 49.064h7.045v-8.859h-7.045zM32.881 49.064h7.045v-8.859h-7.045zM40.866 49.064h7.045v-8.859h-7.045zM48.85 49.064h7.045v-8.859H48.85zM56.834 49.064h7.045v-8.859h-7.045zM64.819 49.064h7.045v-8.859h-7.045zM72.803 49.064h7.045v-8.859h-7.045zM80.787 49.064h7.045v-8.859h-7.045zM88.772 49.064h7.045v-8.859h-7.045zM96.756 9.901h7.045V1.042h-7.045zM104.74 9.901h7.045V1.042h-7.045zM96.756 19.691h7.045v-8.858h-7.045zM104.74 19.691h7.045v-8.858h-7.045zM96.756 29.482h7.045v-8.858h-7.045zM104.74 29.482h7.045v-8.858h-7.045zM96.756 39.273h7.045v-8.858h-7.045zM104.74 39.273h7.045v-8.858h-7.045zM96.756 49.064h7.045v-8.859h-7.045zM104.74 49.064h7.045v-8.859h-7.045z'/%3E%3Cpath d='M23.233 22.584c1.584 0 2.465-.75 2.465-2.047 0-1.274-.83-1.998-2.29-1.998h-1.106v4.045h.93zm.93 7.29c1.76 0 2.667-.774 2.667-2.247 0-1.548-.981-2.322-2.968-2.322h-1.56v4.57h1.862zm-5.281-13.982h5.508c2.817 0 4.678 1.673 4.678 4.17 0 1.823-.855 2.971-2.64 3.57 2.665.675 3.923 1.998 3.923 4.195 0 2.821-2.113 4.694-5.307 4.694h-6.162V15.892zM38.808 26.104c-.15-1.398-1.005-2.197-2.288-2.197-1.233 0-2.113.799-2.365 2.197h4.653zm2.843 4.02c-.93 1.773-2.792 2.796-5.131 2.796-3.346 0-5.584-2.222-5.584-5.567 0-3.446 2.264-5.743 5.659-5.743 3.22 0 5.307 2.147 5.307 5.468v1.049H34.18c.152 1.473 1.007 2.271 2.415 2.271 1.182 0 1.886-.449 2.465-1.548l2.59 1.274zM42.795 22.01h3.018v1.348c.98-1.249 1.987-1.748 3.546-1.748 2.44 0 3.622 1.298 3.622 3.92v6.99h-3.144v-6.166c0-1.473-.528-2.122-1.735-2.122-1.46 0-2.164.973-2.164 2.97v5.319h-3.143V22.01M57.068 27.327c0 1.773 1.107 2.972 2.742 2.972 1.736 0 2.842-1.174 2.842-3.021 0-1.798-1.157-3.046-2.817-3.046-1.61 0-2.767 1.298-2.767 3.095zm5.433 3.995c-.955 1.099-1.961 1.548-3.546 1.548-3.069 0-5.156-2.247-5.156-5.592 0-3.321 2.087-5.593 5.156-5.593 1.358 0 2.288.35 3.37 1.298l-.001-7.126h3.109l.036 16.664H62.5v-1.199zM74.242 26.104c-.151-1.398-1.006-2.197-2.29-2.197-1.232 0-2.112.799-2.364 2.197h4.654zm2.842 4.02c-.93 1.773-2.792 2.796-5.131 2.796-3.345 0-5.584-2.222-5.584-5.567 0-3.446 2.264-5.743 5.66-5.743 3.219 0 5.306 2.147 5.306 5.468v1.049h-7.721c.15 1.473 1.005 2.271 2.414 2.271 1.182 0 1.887-.449 2.465-1.548l2.59 1.274zM78.227 22.01h3.019v1.897c.93-1.598 1.71-2.197 2.892-2.197.226 0 .453.025 1.006.1v3.37c-.754-.25-1.207-.35-1.735-.35-1.283 0-2.037.925-2.037 2.497v5.194h-3.145V22.01M87.778 29.175c.504 1.024.982 1.423 1.736 1.423.654 0 1.132-.374 1.132-.924 0-.599-.251-.774-2.113-1.473-2.187-.848-2.867-1.622-2.867-3.22 0-2.073 1.71-3.52 4.15-3.52 2.012 0 3.27.773 4.024 2.446L91.4 25.13c-.502-.973-.905-1.298-1.61-1.298-.603 0-1.005.35-1.005.874 0 .6.352.849 1.81 1.323 2.315.75 3.22 1.723 3.22 3.446 0 2.147-1.635 3.545-4.2 3.545-2.063 0-3.42-.799-4.3-2.522l2.463-1.323' fill='%23005093' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E")
    background-repeat: no-repeat
    background-position: center
    background-size: cover
    width: 113px
    height: 50px
    margin-bottom: 40px

  .disclaimer
    font-size: 2rem !important
    margin-top: 50px
    margin-bottom: 25px
</style>
